import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { CssValues, OptionTypes } from '../constants';
import {
  getCalendar,
  selectCalendarDate,
  getCalendarRules
} from '../actions/calendar';

class DeliveryDateCalendar extends Component {
  today = {};
  calendar = [];

  componentWillMount() {
    this.props.getCalendar();
    this.props.getCalendarRules();
  }
  handleClick(date) {
    if (date.in_month && date.startable) {
      this.props.selectCalendarDate(date.date);
    }
  }
  handleClickRight() {
    const box = document.getElementById('wrapCalendarList');
    box.scrollTo(CssValues.CALENDAR_PAGE_WIDTH, 0);
  }
  handleClickLeft() {
    const box = document.getElementById('wrapCalendarList');
    box.scrollTo(0 - CssValues.CALENDAR_PAGE_WIDTH, 0);
  }
  renderCalendar(month, mk, selected, rangeStart, rangeEnd) {
    return (
      <div key={mk} className="wrapCalendarTable">
        <table className="calendarTable">
          <caption>
            {month[0][0].year + '年' + month[0][0].month + '月'}
          </caption>
          <thead>
            <tr>
              {['日', '月', '火', '水', '木', '金', '土'].map((day, dk) => (
                <th key={dk}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {month.map((week, wk) => (
              <tr key={wk}>
                {week.map((date, dk) => (
                  <td
                    key={dk}
                    className={
                      'day'+dk +
                      (date.holiday ? ' holiday' : '') +
                      (date.startable && date.in_month ? ' startable' : '') +
                      (date.ok && date.in_month ? ' ok' : '') +
                      (date.date === selected ? ' selected' : '') +
                      (rangeStart < date.time && date.time <= rangeEnd
                        ? ' inRange'
                        : '')
                    }
                    onClick={() => {
                      this.handleClick(date);
                    }}
                  >
                    {date.in_month ? date.day : null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  render() {
    const { calendar, speedTypeId } = this.props;
		const slow_days = calendar.rangeDays ? calendar.rangeDays[0]:OptionTypes.SPEED_TYPE_SLOW_DAYS;
		const speed_days = calendar.rangeDays ? calendar.rangeDays[1]:OptionTypes.SPEED_TYPE_SPEED_DAYS;
		const rangeDays = speedTypeId === OptionTypes.SPEED_TYPE_SLOW ? slow_days : speed_days;
    let arrSelected = '';
    if (calendar.selected !== '') {
      arrSelected = calendar.selected
        .split('-')
        .map((v, k) => ('00' + v).slice(k ? -2 : -4))
        .join('-');
    }
    const selectedDate = new Date(arrSelected);
    const rangeStart = selectedDate.getTime() / 1000;
    selectedDate.setDate(selectedDate.getDate() + rangeDays);
    const rangeEnd = selectedDate.getTime() / 1000;

    const calendarBox = _.chunk(
      calendar.list.map(month => _.chunk(month, 7)),
      2
    );
    return (
      <div className="DeliveryDateCalendarComponent">
        <div className="deliveryDateLine">
          <div className="deliveryDateTitle">配布開始希望日</div>
          <div className="deliveryDateText">{calendar.selected}</div>
        </div>
        <div id="wrapCalendarList" className="wrapCalendarList">
          <div className="calendarList">
            {calendarBox.map((calendarTable, ck) => (
              <div key={ck} className="calendarPage">
                <div className="inner">
                  {ck === 1 ? (
                    <div onClick={this.handleClickLeft}>
                      <svg className="buttonLeft" width="10" height="10">
                        <path d="M10 0 L0 5 L10 10 Z" />
                      </svg>
                    </div>
                  ) : null}
                  {calendarTable.map((month, mk) =>
                    this.renderCalendar(
                      month,
                      mk,
                      calendar.selected,
                      rangeStart,
                      rangeEnd
                    )
                  )}
                  {ck === 0 ? (
                    <div onClick={this.handleClickRight}>
                      <svg className="buttonRight" width="10" height="10">
                        <path d="M0 0 L10 5 L0 10 Z" />
                      </svg>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  calendar: state.calendar,
  speedTypeId: state.options.selected.speedTypeId
});

const mapDispatchToProps = dispatch => ({
  getCalendar: () => dispatch(getCalendar()),
  getCalendarRules: () => dispatch(getCalendarRules()),
  selectCalendarDate: date => dispatch(selectCalendarDate(date))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeliveryDateCalendar);



// WEBPACK FOOTER //
// ./src/components/DeliveryDateCalendar.js